import msIcon from 'assets/images/social_media_ms.svg';
import { GenericConnection } from './generic-connection';
import { Integration } from 'services/integration-service';

/**
 * SharePoint Connection Component
 * 
 * Provides interface for connecting Microsoft SharePoint to the application.
 * Uses the generic connection component with SharePoint specific configuration.
 * 
 * @param onBack - Callback function to go back to connectors list
 * @param existingIntegration - Existing integration if any
 * @returns A SharePoint connection interface
 */

interface SharePointConnectionProps {
    onBack: () => void;
    existingIntegration?: Integration;
}

const sharePointConfig = {
    id: 'microsoft-sharepoint',
    name: 'Microsoft SharePoint',
    description: 'Search and reference files from your SharePoint sites.',
    longDescription: 'Connect Microsoft SharePoint to access and search through your organization\'s shared documents, files, and resources. This integration brings enterprise-level content management directly into your workflow, enabling deep research and intelligent agent capabilities across your SharePoint sites. Ideal for organizations that rely on SharePoint for document collaboration and knowledge management.',
    icon: msIcon,
    iconAlt: 'Microsoft SharePoint',
    category: 'Productivity',
    developer: 'Microsoft',
    website: 'https://sharepoint.microsoft.com',
    privacyPolicy: 'https://privacy.microsoft.com'
};

export const SharePointConnection = ({ onBack, existingIntegration }: SharePointConnectionProps) => {
    return (
        <GenericConnection
            onBack={onBack}
            integrationConfig={sharePointConfig}
            existingIntegration={existingIntegration}
        />
    );
};
